import classNames, { Argument } from 'classnames';
import React from 'react';
import { FormattedMessage, FormattedNumber } from 'react-intl';

type PreAutorizedAmountLineProps = {
  amount: number,
  currencyIsoCode: string,
  className?: Argument
};

const PreAutorizedAmountLine: React.FC<PreAutorizedAmountLineProps> = ({ amount, currencyIsoCode, className }) => (
  <div className={classNames(className)}>
    <FormattedMessage id="preAuthorizedAmounts.label" defaultMessage="Customer share" tagName="span" />

    {amount === 0 && (<FormattedMessage id="preAuthorizedAmounts.freeOfCharge" defaultMessage="Free of charge" tagName="span" />)}
    {amount > 0 && (
      <span>
        <FormattedNumber
          value={amount}
          style="currency"
          currency={currencyIsoCode}
        />
      </span>
    )}
  </div>
);

export default PreAutorizedAmountLine;
